var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAckoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "acko-logo_svg__a",
    d: "M0 .032h43.965v13.863H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .004)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "acko-logo_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#acko-logo_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#582CDB",
    fillRule: "nonzero",
    mask: "url(#acko-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.932.032H7.033C3.15.032 0 3.154 0 7.004c0 3.85 3.067 6.892 6.952 6.892H36.85c3.884 0 7.115-3.041 7.115-6.892 0-3.85-3.149-6.972-7.033-6.972"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M36.656 12.186c-2.89 0-5.241-2.331-5.241-5.196 0-2.866 2.351-5.196 5.241-5.196 2.89 0 5.242 2.33 5.242 5.196 0 2.865-2.351 5.196-5.242 5.196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25CB7B",
    fillRule: "nonzero",
    d: "M36.656 10.534c-1.974 0-3.575-1.587-3.575-3.544 0-1.958 1.6-3.544 3.575-3.544s3.576 1.586 3.576 3.544c0 1.957-1.601 3.544-3.576 3.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M7.3 10.513c-1.96 0-3.554-1.58-3.554-3.523S5.34 3.466 7.301 3.466c1.96 0 3.554 1.58 3.554 3.524 0 1.943-1.594 3.523-3.554 3.523m5.236-3.523c0-2.862-2.349-5.191-5.236-5.191-2.888 0-5.237 2.329-5.237 5.19 0 2.863 2.35 5.192 5.237 5.192 1.37 0 2.62-.526 3.554-1.383v.55c0 .46.377.833.841.833a.838.838 0 00.841-.834v-4.19l-.001-.047.001-.12m6.37 5.196c-2.907 0-5.272-2.345-5.272-5.227 0-2.883 2.365-5.227 5.273-5.227 1.304 0 2.555.475 3.524 1.339.348.31.376.84.064 1.184a.853.853 0 01-1.195.063 3.595 3.595 0 00-2.393-.91c-1.975 0-3.581 1.593-3.581 3.55 0 1.958 1.606 3.55 3.58 3.55a3.59 3.59 0 002.395-.91.852.852 0 011.195.063.834.834 0 01-.063 1.184 5.292 5.292 0 01-3.526 1.34m12.58-1.521L26.952 6.89l4.538-3.696a.829.829 0 00.11-1.174.847.847 0 00-1.184-.11l-4.917 4.042v-3.4a.837.837 0 00-.84-.833.838.838 0 00-.842.833v8.753c0 .46.377.834.841.834a.837.837 0 00.841-.834v-3.4l4.917 4.042a.842.842 0 001.184-.11.828.828 0 00-.11-1.173"
  }))));
}
export default SvgAckoLogo;